<template>
  <div>
    <div class="history-header total-head" v-if="remark && list.length">
      User Limit ID: {{list[0].riskLevelId}}
      <span
        class="history-time"
        v-if="list[0].createTime"
      >Set Time: {{formatUtc(list[0].createTime)}}</span>
    </div>
    <div v-for="(item,index) in list" :key="index">
      <div class="history-header" v-if="remark">
        <span v-if="item.updateTime">Modify Time: {{formatUtc(item.updateTime)}}</span>
        <span class="history-time">User Limit Name: {{item.riskLevel}}</span>
      </div>
      <SportList :sport-list="sportList" :list="item[iskey]" :loading="loading" />
      <div class="remark-wrapper" v-if="remark">
        <div class="remark-head">Remark</div>
        <div class="remark-contain text-remark-contain">{{item.remark}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import SportList from "./tableItem";
import { getTcsSportList } from "@/api/memberDetail";
export default {
  components: {
    SportList
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    iskey: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    remark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sportList: []
    };
  },
  methods: {
    async getSportList() {
      try {
        const res = await getTcsSportList({ matchType: '' });
        const data = res.data || {};
        this.sportList = data || [];
      } catch (error) {
        this.sportList = [];
      }
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    }
  },
  mounted() {
    this.getSportList();
  }
};
</script>
<style lang="scss" scoped>
</style>
